import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/config/supabase';
import { useAuthStore } from '@/store/authStore';

/**
 * Subscribes to live `decision_approvals` changes for the signed-in
 * member's assignments (research.md §14 — the one flow the requirements
 * explicitly call out for real-time updates) and invalidates the relevant
 * queries so "My Approvals" / the Dashboard pending-approvals count update
 * without a manual refresh.
 */
export function useApprovalsRealtime() {
  const queryClient = useQueryClient();
  const memberId = useAuthStore((s) => s.member?.id);

  useEffect(() => {
    if (!memberId) return;

    const channel = supabase
      .channel('my-approvals')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'decision_approvals', filter: `assigned_to=eq.${memberId}` },
        () => {
          queryClient.invalidateQueries({ queryKey: ['approvals'] });
          queryClient.invalidateQueries({ queryKey: ['dashboard', 'pendingCount'] });
          queryClient.invalidateQueries({ queryKey: ['dashboard', 'pendingApprovals'] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [memberId, queryClient]);
}
